const overrides = (palette, typography) => ({
  root: {}
})

export default overrides
